<template>
  <div>
    <PageTitle class="title" imagem="copiarplanoproducao.png" main="Visualizar Lista Técnica" sub="" />

    <div class="print-container ml-4 mb-2">
      <div class="ref-select referenceInfoYear">
        <p class="mr-2 yearText noselect">Ano Base</p>
        <b-form-select v-model="yearSelected" class="select-view noselect">
          <template #first>
            <b-form-select-option :value="null">Selecione o ano</b-form-select-option>
          </template>
          <b-form-select-option v-for="year in years" :key="year.id" :value="year.baseYear">{{ year.baseYear
          }}</b-form-select-option>
        </b-form-select>
      </div>
      <download-excel name="Relatório da Lista Técnica" :fetch="GerarExcel">
        <img class="ml-3 printer-button" src="@/assets/excel.png" :title="$t('gerar-relatorio')" :alt="$t('imprimir')" />
        <span v-if="loadingReport" class="spinner-border spinner-border-sm spinnerConfig" role="status"
          aria-hidden="true"></span>
      </download-excel>
    </div>

    <div class="tableSection">
      <b-row v-if="loaded">
        <b-col class="table-responsive-md table-wrapper-scroll-y my-custom-scrollbar">
          <table id="innerTable" class="table table-hover table-sm">
            <thead class="thead-dark title-calendar">
              <th scope="col" class="table-name">
                <button @click="beforeQuarter()" class="button-pagination">
                  <b-icon icon="arrow-left" aria-hidden="true"></b-icon>
                </button>
                {{ counter }} - 3
                <button @click="nextQuarter()" class="button-pagination">
                  <b-icon icon="arrow-right" aria-hidden="true"></b-icon>
                </button>
              </th>
              <th v-for="(period, index) in valuesPlan.slicePeriod" :key="index" scope="col" colspan="2"
                class="table-span2">
                {{ period.description }}
              </th>
              <th scope="col" class="table-unit title-unit"></th>
            </thead>

            <thead class="thead-dark title-vars">
              <th scope="col" class="table-name">Nome</th>
              <th class="table-normal" v-for="(period, index) in valuesPlan.slicePeriod" :key="index + 20" scope="col">
                {{ index % 2 == 0 ? "Produção" : "Específico" }}
              </th>
              <th class="table-normal" v-for="(period, index) in valuesPlan.slicePeriod" :key="index" scope="col">
                {{ index % 2 != 0 ? "Específico" : "Produção" }}
              </th>
              <th scope="col" class="table-unit title-unit">Unidade</th>
            </thead>

            <template v-if="!valuesPlan.table">
              Sem dados para visualização<br />
            </template>

            <tbody>
              <tr v-for="(line, i) in valuesPlan.table" :key="i">
                <td v-for="(col, j) in line" :key="j" :class="{
                  area: isHeader[i].root == 'true',
                  'table-name': j == 'name',
                  'table-unit': j == 'unit',
                  'table-normal': j != 'name' && j != 'unit',
                }" :title="line[j]">
                  {{
                    j == "unit"
                    ? col
                    : j.includes("specificValue") &&
                      isHeader[i].root == "true" &&
                      col != ""
                      ? col
                      : col != ""
                        ? fixNumber(col)
                        : "-"
                  }}
                </td>
              </tr>
            </tbody>
          </table>
        </b-col>
      </b-row>

      <b-row v-else-if="yearSelected == null" class="waitTxt rowDistance">
        Selecione ano base ...
      </b-row>

      <b-row v-else-if="!calcError" class="waitTxt rowDistance">
        Aguardando banco de dados ...
      </b-row>

      <b-card class="error-calc" v-else>
        <p>Ops, falha na obtenção dos dados...</p>
        <p>Tente revisar o planejamento e a configuração da lista técnica...</p>
      </b-card>
    </div>
  </div>
</template>

<script>
import { urlMainAPI, defaultSuccess } from "@/global";
import PageTitle from "../template/PageTitle";

import axios from "axios";

export default {
  name: "BillOfMatirial",

  components: { PageTitle },

  data() {
    return {
      loadingReport: false,
      valuesPlan: [],
      isHeader: [],
      loaded: false,
      calcError: false,
      counter: 1,
      yearSelected: null,
      years: []
    };
  },
  watch: {
    async yearSelected(value) {
      await this.loadTable(value);
    }
  },

  computed: {},
  methods: {
    async loadTable(year) {
      if (year != null) {
        defaultSuccess(this.$t('carregando-dados'));
        const url = `${urlMainAPI}/calculateLtPlan/false/${this.counter}/${year}`;
        await axios
          .get(url)
          .then((res) => {
            if (!res) {
              this.calcError = true;
              return;
            }

            this.valuesPlan = res.data;
            this.buildTable();
            this.loaded = true;
            defaultSuccess(this.$t('dados-carregados'));
            return true;
          })
          .catch(() => {
            console.error("Erro ao carregar os dados da lista técnica...");
            return false;
          });
      }
    },

    buildTable() {
      let unitRoot = "-";

      this.valuesPlan.table.forEach((element) => {
        let unit = this.ArrumarUnit(element.unit);
        this.isHeader.push({ root: element.root });
        delete element.id;
        delete element.unit;

        if (element.root == "true") {
          unitRoot = unit;
          element.unit = unitRoot;
        } else {
          element.unit = this.unitDivision(unit, unitRoot);
        }

        element.root && delete element.root;
      });
    },

    hasScrolling() {
      if (this.yearSelected != null) {
        if (this.valuesPlan.table.length > 14) {
          document.querySelectorAll(".title-unit").forEach((el) => {
            el.classList.add("unit-title");
          });
        }
      }
    },

    async beforeQuarter() {
      this.counter = this.counter == 1 ? 3 : --this.counter;
      this.loaded = false;
      this.isHeader = new Array();
      await this.loadTable(this.yearSelected);
      window.location.href = "#innerTable";
    },

    async nextQuarter() {
      this.counter = this.counter == 3 ? 1 : ++this.counter;
      this.loaded = false;
      this.isHeader = new Array();
      await this.loadTable(this.yearSelected);
      window.location.href = "#innerTable";
    },

    fixNumber(num) {
      try {
        if (num == null || num == "-9999") {
          return "-";
        }

        return num;
      } catch (error) {
        return "-";
      }
    },

    ArrumarUnit(e) {
      let tempName = "";
      let tempNameArr = [];
      if (e.indexOf("/") != -1) {
        tempNameArr = e.split("/");
        tempName += tempNameArr[0];
        return tempName;
      } else {
        return e;
      }
    },

    unitDivision(var1, var2) {
      if (var2 != "-") {
        var1 = var1.replace(")", "").replace("(", "");
        var2 = var2.replace(")", "").replace("(", "");
        var1 = this.ArrumarUnit(var1);
        return `${var1}/${var2}`;
      }
      return "-";
    },

    async GerarExcel() {
      this.loadingReport = true;
      const url = `${urlMainAPI}/calculateLtPlan/true/${this.counter}/${this.yearSelected}`;
      const response = await this.$http.get(url);
      if (response.data.length == 0) {
        defaultSuccess(this.$t("excel-zerado"));
      } else {
        defaultSuccess(this.$t("excel-lista-tecnica-exportado-com-sucesso"));
      }
      this.loadingReport = false;
      return response.data.table;
    },

    async loadBaseYears() {
      const url = `${urlMainAPI}/getproductionplanswithrevisionsbyyear`;
      await axios
        .get(url)
        .then((res) => {
          this.years = res.data;
        })
        .catch();
    },
  },

  async mounted() {
    await this.loadBaseYears();
    await this.loadTable(this.yearSelected);
    this.hasScrolling();
  },
};
</script>

<style scoped>
.print-container {
  display: flex;
  flex-wrap: nowrap;
  width: auto;
}

.printer-button {
  position: absolute;
  height: 30px;
  width: 30px;
  cursor: pointer;
  top: 1rem;
  right: 1rem;
}

.spinnerConfig {
  width: 1.5rem; 
  height: 1.5rem;
  color: #ff5f00;
  position: absolute;
  top: 1.2rem;
  right: 3.5rem;
}

table {
  border-collapse: initial;
  border-spacing: initial;
  font-size: 0.8rem;
  border: 1px solid #0002;
}

table thead,
table tbody {
  display: block;
  font-size: 0.75em;
}

.title-calendar th {
  text-align: center;
  border-right: solid 1px honeydew;
}

.title-calendar th:last-child {
  border-right: none;
}

table tbody {
  overflow: auto;
  height: 400px;
}

.title-vars {
  text-align: start;
}

.table-span2 {
  min-width: 200px;
}

.table-name {
  min-width: 200px;
  width: 100%;
}

.table-normal {
  min-width: 100px;
  text-align: right;
}

.table-unit {
  text-align: center;
  min-width: 80px;
}

.unit-title {
  min-width: 97px;
}

.button-pagination {
  color: white;
  background-color: #00000030;
  border-radius: 4px;
  font-size: 0.65rem;
  font-weight: 700;
  margin: 0 5% 0 5%;
  padding: 0 10px 1px 10px;
  outline: none;
  box-shadow: 2px 2px 2px #00000030;
}

.button-pagination:hover {
  background-color: #0001;
}

.my-custom-scrollbar {
  overflow: auto;
  margin: 0px auto;
  padding-left: 0px;
  padding-right: 0px;
}

.waitTxt {
  justify-content: center;
  background: black;
  color: white;
  margin: 10px auto;
  min-width: 300px;
  max-width: 400px;
}

.rowDistance {
  margin-top: 20px;
}

.tableSection {
  display: flex;
  justify-content: center;
  margin: 15px;
}

.area {
  background-color: rgb(59, 58, 58);
  color: white;
}

.error-calc>div {
  background-color: rgb(250, 250, 250);
  display: flex;
  flex-direction: column;
  align-items: center;
}

.error-calc {
  margin-top: 30px;
}

.error-calc>div>img {
  height: 60px;
  width: 200px;
}

.error-calc>div>p {
  margin: 0;
  font-weight: 500;
}

.ref-select {
  display: flex;
}

.ref-select>p,
.ref-select select {
  margin: 0;
  font-size: 0.85rem;
}

.ref-select select {
  height: 25px;
  padding: 1px 5px;
  min-width: 140px;
}

.referenceInfoYear {
  font-size: 0.85rem;
  color: #ff5f00;
  white-space: nowrap;
  text-overflow: ellipsis !important;
  text-align: center;
}

.yearText {
  margin: 0;
  margin-top: 2px !important;
}

.select-view {
  min-width: 100px;
}

/* height */
@media (min-height: 720px) {
  table tbody {
    height: 480px;
  }
}

@media (min-height: 800px) {
  table tbody {
    height: 576px;
  }
}

@media (min-height: 1051px) {
  table tbody {
    height: 745px;
  }
}

/* width */

@media (max-width: 1100px) {
  table {
    font-size: 0.7rem;
  }

  .tableSection {
    justify-content: start;
    margin: 15px;
  }
}

@media (max-width: 400px) {
  table {
    font-size: 0.6rem;
  }

  .tableSection {
    justify-content: start;
    margin: 15px;
  }

  .table-span2 {
    min-width: 160px;
  }

  .table-name {
    min-width: 140px;
  }

  .table-normal {
    min-width: 80px;
    text-align: right;
  }

  .table-unit {
    text-align: center;
    min-width: 50px;
  }
}

@media (min-width: 1440px) {
  table {
    font-size: 1rem;
  }

  .table-span2 {
    min-width: 260px;
  }

  .table-name {
    min-width: 230px;
    width: 100%;
  }

  .table-normal {
    min-width: 130px;
    text-align: right;
  }

  .table-unit {
    text-align: center;
    min-width: 100px;
  }
}

@media (min-width: 1766px) {
  table {
    font-size: 1.3rem;
  }

  .table-span2 {
    min-width: 330px;
  }

  .table-name {
    min-width: 250px;
    width: 100%;
  }

  .table-normal {
    min-width: 165px;
    text-align: right;
  }

  .table-unit {
    text-align: center;
    min-width: 120px;
  }
}

/* Botão */
@media screen and (max-width: 1366px) {
  .print-container {
    width: auto;
    margin-bottom: auto !important;
    margin-left: 6.2rem !important;
  }
}

</style>
